import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import BlueButton from "../Button/BlueButton";
import WhiteButton from "../Button/WhiteButton";
import { useUserType } from "../../contexts/UserTypeContext";
import showToast from "../Toast/Toster";
import { LoaderComponent } from "../Icon/Index";
import AxiosInstance from "../../utils/axiosInstance";

const PayaAddCardForm = ({ onSuccess, onCancel, CustomerId, CompanyId }) => {
  const [loading, setLoading] = useState(false);
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";

  const [formData, setFormData] = useState({
    cardNumber: "",
    expiryDate: "",
    cvv: "",
    nameOnCard: "",
    billingZip: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === "cardNumber") {
      formattedValue = value.replace(/\D/g, "").slice(0, 16);
    } else if (name === "expiryDate") {
      formattedValue = value
        .replace(/\D/g, "")
        .slice(0, 4)
        .replace(/(\d{2})(\d{2})/, "$1/$2");
    } else if (name === "cvv") {
      formattedValue = value.replace(/\D/g, "").slice(0, 4);
    } else if (name === "billingZip") {
      formattedValue = value.replace(/\D/g, "").slice(0, 5);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const payload = {
        cardDetails: {
          ...formData,
          CustomerId,
          CompanyId,
          type: "paya",
        },
      };

      const response = await AxiosInstance.post("/v1/paya/add-card", payload);

      if (response?.data?.statusCode === 200) {
        showToast.success("Card added successfully");
        onSuccess(response.data);
      } else {
        showToast.error(response?.data?.message || "Failed to add card");
      }
    } catch (error) {
      const errorMessage =
        typeof error === "string"
          ? error
          : (error?.response?.data?.data?.error ||
             error?.response?.data?.error ||
             error?.response?.data?.message ||
             error?.message ||
             "We couldn't save your card. Please try again in a moment.");
      showToast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h6" style={{ marginBottom: "20px" }}>
        Paya Add Card Form
      </Typography>
    </>
  );
};

export default PayaAddCardForm;
